import { render, staticRenderFns } from "./ManagementDashboard.vue?vue&type=template&id=61afc272&scoped=true&"
import script from "./ManagementDashboard.vue?vue&type=script&lang=ts&"
export * from "./ManagementDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementDashboard.vue?vue&type=style&index=0&id=61afc272&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61afc272",
  null
  
)

export default component.exports